var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12.5","cy":"8.95996","r":"7.5","stroke":"#C27247","fill":"none","strokeWidth":"2","key":0}),React.createElement("rect",{"x":"1.32039","y":"19.125","width":"7.22305","height":"1","transform":"rotate(-45 1.32039 19.125)","fill":"#888888","stroke":"#C27247","key":1})]);
}

Search.defaultProps = {"viewBox":"0 0 21 21","fill":"none"};

module.exports = Search;

Search.default = Search;
